import navDropHeight from "./navDropHeight";

export default function slidingMenu() {
  var arr = [];
  var $nav = $(".main-nav"),
    $mainNavContainer = $(".menu-container"),
    $navItems = $nav.find("li"),
    $dropdown = $navItems.has("ul").addClass("dropdown"),
    $dropdownOpener = $dropdown.find('.arrow'),
    $back_btn = $(".back-btn");

  // open sub-level
  $dropdownOpener.on("click", function (e) {
    if (window.innerWidth < 1025) {
      $mainNavContainer = $(".menu-container"),
        $navItems = $(this).closest('li');
      var $viewMoreBtn = $('.view-all'),
        $dropdownActive = $(this).closest('.dropdown');

      arr.push($dropdownActive);
      $mainNavContainer.addClass("lvl-" + arr.length);

      var categoryName = $(this).siblings('a').text();
      var categoryNameUrl = $(this).siblings('a').attr('href');
      $('.category-name').text(categoryName);

      $(this).parents('.dropdown').removeClass("active-lvl");
      $(this).closest('.dropdown').addClass("active-lvl");
      $(this).parents('.dropdown').addClass("is-open");
      $(this).parents('.menu-container').addClass("is-drop-active");

      navDropHeight();

      $viewMoreBtn.attr('href', categoryNameUrl);
    }
  });

  // go back
  $back_btn.on("click", function (e) {
    e.stopPropagation();
    $mainNavContainer.removeClass("lvl-" + arr.length);
    $(this).closest('.is-open').removeClass("is-open");

    arr.pop();
    $('.category-name').text((arr.length > 0) ? arr[arr.length - 1].children('a').first().text() : 'Menu')
    if (arr.length == 0) {
      $('.menu-container').removeClass("is-drop-active");
    }

    $(this).parents('.dropdown').removeClass("active-lvl");
    $(this).closest('.dropdown.is-open').addClass("active-lvl");
  });
}